<div class='licence-plate' *ngIf='country && licence'>
  <div class='country'>
    {{ country }}
  </div>
  <div class='license'>
    {{ licence }}
  </div>
</div>
